<template>

  <div class="page-cover">

    <!-- 这里是图表的div -->
    <div class="main-area">
      <div class="header-wrap van-clearfix">
        <div class="date-picker-block" @click="openCalendar">
          <div class="date">{{ date }}
            <van-icon name="arrow-down"/>
          </div>
        </div>
      </div>
      <div class="chart-title">云上草原客流趋势</div>
      <div class="btn-group">
        <el-button-group>
          <el-button size="mini" @click="chooseType('2')" type="primary" v-if="currentChooseType === '2'">按月</el-button>
          <el-button size="mini" @click="chooseType('2')" v-else>按月</el-button>

          <el-button size="mini" @click="chooseType('1')" type="primary" v-if="currentChooseType === '1'">按周</el-button>
          <el-button size="mini" @click="chooseType('1')" v-else>按周</el-button>

          <el-button size="mini" @click="chooseType('0')" type="primary" v-if="currentChooseType === '0'">按天</el-button>
          <el-button size="mini" @click="chooseType('0')" v-else>按天</el-button>

        </el-button-group>
      </div>
      <div ref="chart" class="main-chart" :class="{'half-height': isPC}"></div>

      <div style="height:0.15rem;"></div>
      <div class="chart-title" style=" border-radius: 0.16rem 0.16rem 0 0;">茅山森林世界客流趋势</div>
      <div class="btn-group">
        <el-button-group>
          <el-button size="mini" @click="chooseType2('2')" type="primary" v-if="currentChooseType2 === '2'">按月</el-button>
          <el-button size="mini" @click="chooseType2('2')" v-else>按月</el-button>

          <el-button size="mini" @click="chooseType2('1')" type="primary" v-if="currentChooseType2 === '1'">按周</el-button>
          <el-button size="mini" @click="chooseType2('1')" v-else>按周</el-button>

          <el-button size="mini" @click="chooseType2('0')" type="primary" v-if="currentChooseType2 === '0'">按天</el-button>
          <el-button size="mini" @click="chooseType2('0')" v-else>按天</el-button>

        </el-button-group>
      </div>
      <div ref="chart2" class="main-chart" :class="{'half-height': isPC}"></div>
      <div style="height: 0.3rem;"></div>
    </div>

    <van-calendar v-model="showCalendar"
                  :default-date="calendarDate"
                  :max-date="new Date(new Date().setDate(new Date().getDate()+365))"
                  :min-date="new Date(2021, 0, 1)"
                  @confirm="onCalendarConfirm"
    />
  </div>

</template>

<script>
import { getScenicPersons } from '@/api/global'
import { removeAccessToken, removeAccessTokenExpiredTime } from '../utils/auth'
// import { getCode } from '../utils/utils'
import '@vant/touch-emulator'

export default {
  name: 'line.vue',
  data: () => {
    return {
      isPC: false,
      loading: true,
      showCalendar: false,
      date: '',
      calendarDate: new Date(),
      randomNumber: 0,
      dataSet: {},
      dataSet2: {},
      currentChooseType: '0',
      currentChooseType2: '0'
    }
  },
  computed: {
    // 计算属性的 getter
    groupDetailHumanFieldName: function () {
      // `this` 指向 vm 实例
      if (this.groupDetailType === 2 || this.groupDetailType === 6) {
        return '人员(到岗日期)'
      } else {
        return '人员(入职日期)'
      }
    }
  },
  created () {

    // 判断是否PC
    if ((navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry)/i
    ))) {
      this.isPC = false
    } else {
      this.isPC = true
    }

    window.scrollTo(0, 0)

    // 清空上次的token
    removeAccessTokenExpiredTime()
    removeAccessToken()

    // 获取当前日期
    this.date = this.formatDate(new Date())

    // 一个随机数 有用的地方就拿来用
    this.randomNumber = Math.floor(Math.random() * 1000)
    console.log('生成一个随机数', this.randomNumber)

    // this.getData()
    this.getData()
  },
  mounted () {
    // this.renderCharts()
  },
  methods: {
    renderCharts () {
      const _this = this
      const chart = this.$refs.chart
      const myChart = this.$echarts.init(chart)
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: _this.dataSet.legends
        },
        grid: {
          left: '3%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: _this.dataSet.xAxisTitle,
          axisLabel: {
            interval: _this.currentChooseType === '0' ? 'auto' : '0',
            rotate: -45,
            formatter: function (value) {
              if(value === _this.dataSet.activeX){
                 let current = value
                 return '{current|' + current + '}'
              }else{
                 let title = value
                 return '{title|' + title + '}'
              }
            },
            margin: 20,
            rich: {
              current: {
                lineHeight: 10,
                align: 'center',
                fontWeight: 'bold',
                fontSize: 14,
                color: '#0366d2'
              },
              title: {
                lineHeight: 10,
                align: 'center',
                fontWeight: 'bold',
                fontSize: 12,
                color: '#424242'
              },
            },
          },
        },
        yAxis: {
          type: 'value',
          name: '人次',
          nameTextStyle:{
            align: 'right',
            padding: [10, 10, 0, 10]
          },
        },
        series: [
          {
            color: '#f3d1a3',
            name: _this.dataSet.legends[2],
            type: 'line',
            data: _this.dataSet.beforeLastYearData,
          },
          {
            color: '#a8f6c6',
            name: _this.dataSet.legends[1],
            type: 'line',
            data: _this.dataSet.lastYearData,
          },
          {
            color: '#41a4ff',
            name: _this.dataSet.legends[0],
            type: 'line',
            data: _this.dataSet.currentYearData,
          }
        ]
      }
      myChart.setOption(option)
      window.addEventListener('resize', function () {
        myChart.resize()
      })
      this.$on('hook:destroyed', () => {
        window.removeEventListener('resize', function () {
          myChart.resize()
        })
      })

      myChart.getZr().off('click')
      myChart.getZr().on('click', async (params) => {
        const pointInPixel = [params.offsetX, params.offsetY]
        if (myChart.containPixel('grid', pointInPixel)) {
          let dataIndex = myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0]
          console.log('dataIndex', dataIndex, myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel))
          // this.goToDetail(myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[1])
        }
      })

    },
    renderCharts2 () {
      const _this = this
      const chart2 = this.$refs.chart2
      const myChart2 = this.$echarts.init(chart2)
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: _this.dataSet2.legends
        },
        grid: {
          left: '3%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: _this.dataSet2.xAxisTitle,
          axisLabel: {
            interval: _this.currentChooseType2 === '0' ? 'auto' : '0',
            rotate: -45,
            formatter: function (value) {
              if(value === _this.dataSet2.activeX){
                let current = value
                return '{current|' + current + '}'
              }else{
                let title = value
                return '{title|' + title + '}'
              }
            },
            margin: 20,
            rich: {
              current: {
                lineHeight: 10,
                align: 'center',
                fontWeight: 'bold',
                fontSize: 14,
                color: '#0366d2'
              },
              title: {
                lineHeight: 10,
                align: 'center',
                fontWeight: 'bold',
                fontSize: 12,
                color: '#424242'
              },
            },
          },
        },
        yAxis: {
          type: 'value',
          name: '人次',
          nameTextStyle:{
            align: 'right',
            padding: [10, 10, 0, 10]
          }
        },
        series: [
          {
            color: '#f3d1a3',
            name: _this.dataSet2.legends[2],
            type: 'line',
            data: _this.dataSet2.beforeLastYearData,
          },
          {
            color: '#a8f6c6',
            name: _this.dataSet2.legends[1],
            type: 'line',
            data: _this.dataSet2.lastYearData,
          },
          {
            color: '#41a4ff',
            name: _this.dataSet2.legends[0],
            type: 'line',
            data: _this.dataSet2.currentYearData,
          }
        ]
      }
      myChart2.setOption(option)
      window.addEventListener('resize', function () {
        myChart2.resize()
      })
      this.$on('hook:destroyed', () => {
        window.removeEventListener('resize', function () {
          myChart2.resize()
        })
      })

      myChart2.getZr().off('click')
      myChart2.getZr().on('click', async (params) => {
        const pointInPixel = [params.offsetX, params.offsetY]
        if (myChart2.containPixel('grid', pointInPixel)) {
          let dataIndex = myChart2.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0]
          console.log('dataIndex', dataIndex, myChart2.convertFromPixel({ seriesIndex: 0 }, pointInPixel))
          // this.goToDetail(myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[1])
        }
      })

    },

    /*goToDetail (index) {
      console.log('goToDetail', index)
      this.$router.push('/detail/' + this.dataSet.hotelList[index].id + '/' + this.date)
    },*/
    openCalendar () {
      this.showCalendar = true

      this.$nextTick(() => {
        const dom = document.querySelector('.van-calendar__body')
        if (dom) {
          let back = dom.scrollTop
          // 10毫秒的时候动一下 100毫秒再动回去 2022.05.05 实测全面屏的手机有日历白屏的现象
          setTimeout(() => {
            back = dom.scrollTop
            dom.scrollTop = back - 40
            console.log('scroll-start', back)
          }, 10)
          setTimeout(() => {
            dom.scrollTop = back
            console.log('scroll-end')
          }, 100)
        }
      })

    },
    onCalendarConfirm (date) {
      this.calendarDate = date
      this.showCalendar = false
      this.date = this.formatDate(date)
      this.getData()
    },
    formatDate (date) {
      return `${date.getFullYear()}-${this.repairZero(date.getMonth() + 1)}-${this.repairZero(date.getDate())}`
    },
    repairZero (num) {
      return num < 10 ? '0' + num : num
    },
    dateFilter (time) {
      const date = new Date(time)
      return date.getFullYear() + '-' + this.repairZero(date.getMonth() + 1) + '-' + this.repairZero(date.getDate())
    },
    thousandsFilter (number) {
      let arr = String(number).split('.')
      let num = arr[0]
      let len = Math.ceil(num.length / 3) * 3
      let result = num.padStart(len, '0').match(/\d{3}/g).join(',').replace(/^0+/, '')
      return arr[1] ? result + '.' + arr[1] : result
    },
    chooseType2(currentChooseType2) {
      console.log(currentChooseType2)
      const _this = this
      _this.currentChooseType2 = currentChooseType2
      // 请求数据
      this.tableData = []
      this.totalData = {}
      // 加载动画开始
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      // 森林数据
      getScenicPersons('72', this.date, this.currentChooseType2).then((data) => {

        // // 加载动画结束
        this.$toast.clear()
        console.log('getScenicPersons', data)

        // 有数据
        const dataSet2 = {}
        dataSet2.currentYearData = data.personCounts.item1
        dataSet2.lastYearData = data.personCounts.item2
        dataSet2.beforeLastYearData = data.personCounts.item3
        dataSet2.xAxisTitle = data.dateList
        dataSet2.activeX = data.activeX
        dataSet2.legends = data.legends

        this.dataSet2 = dataSet2
        // 渲染表格
        this.renderCharts2()

      }).catch((err) => {
        // 网络错误
        console.log(err)
        this.$toast.clear()
        this.$toast('网络异常 请稍后再试')
      })
    },
    chooseType(currentChooseType) {
      console.log(currentChooseType)
      const _this = this
      _this.currentChooseType = currentChooseType
      // 请求数据
      this.tableData = []
      this.totalData = {}
      // 加载动画开始
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      getScenicPersons('82', _this.date, _this.currentChooseType).then((data) => {

        // // 加载动画结束
        this.$toast.clear()
        console.log('getScenicPersons', data)

        // 有数据
        const dataSet = {}
        dataSet.currentYearData = data.personCounts.item1
        dataSet.lastYearData = data.personCounts.item2
        dataSet.beforeLastYearData = data.personCounts.item3
        dataSet.xAxisTitle = data.dateList
        dataSet.activeX = data.activeX
        dataSet.legends = data.legends

        this.dataSet = dataSet
        // 渲染表格
        this.renderCharts()

      }).catch((err) => {
        // 网络错误
        console.log(err)
        this.$toast.clear()
        this.$toast('网络异常 请稍后再试')
      })
    },
    getData () {
      // 请求数据
      this.tableData = []
      this.totalData = {}
      // 加载动画开始
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })

      // 云上数据
      getScenicPersons('82', this.date, this.currentChooseType).then((data) => {

        // // 加载动画结束
        this.$toast.clear()
        console.log('getScenicPersons', data)
        // this.loggingData = data
        // console.log('loggingData', data)

        // 没数据
        /*if (!data.hasData) {
          this.$toast('当前日期暂无数据')
          this.dataSet = {}
          this.renderCharts()
          return false
        }*/

        // 有数据
        const dataSet = {}
        dataSet.currentYearData = data.personCounts.item1
        dataSet.lastYearData = data.personCounts.item2
        dataSet.beforeLastYearData = data.personCounts.item3
        dataSet.xAxisTitle = data.dateList
        dataSet.activeX = data.activeX
        dataSet.legends = data.legends

        /*dataSet.hotelList = data.hotelList
        dataSet.hotelNameList = data.hotelNameList
        dataSet.lastYearData = data.lastYearData
        dataSet.thisYearData = data.thisYearData
        dataSet.thisYearProportion = data.thisYearProportion
        dataSet.totalCount = data.totalCount
        dataSet.totalRoomCount = data.totalRoomCount*/

        this.dataSet = dataSet
        // 渲染表格
        this.renderCharts()

        // // 后端返回的无权限
        // if (data.stateCode === -1) {
        //   this.$toast('暂无权限查看数据')
        //   return false
        // }
        // // 没数据
        // if (data.data.length <= 0) {
        //   this.$toast('当前日期暂无数据')
        // }
        // // 有数据时的 ★正常情况
        // this.tableData = data.data || []
        // this.totalData = data.footer[0] || {}
      }).catch((err) => {
        // 网络错误
        console.log(err)
        this.$toast.clear()
        this.$toast('网络异常 请稍后再试')
      })

      // 森林数据
      getScenicPersons('72', this.date, this.currentChooseType2).then((data) => {

        // // 加载动画结束
        this.$toast.clear()
        console.log('getScenicPersons', data)
        // this.loggingData = data
        // console.log('loggingData', data)

        // 没数据
        /*if (!data.hasData) {
          this.$toast('当前日期暂无数据')
          this.dataSet = {}
          this.renderCharts()
          return false
        }*/

        // 有数据
        const dataSet2 = {}
        dataSet2.currentYearData = data.personCounts.item1
        dataSet2.lastYearData = data.personCounts.item2
        dataSet2.beforeLastYearData = data.personCounts.item3
        dataSet2.xAxisTitle = data.dateList
        dataSet2.activeX = data.activeX
        dataSet2.legends = data.legends

        /*dataSet.hotelList = data.hotelList
        dataSet.hotelNameList = data.hotelNameList
        dataSet.lastYearData = data.lastYearData
        dataSet.thisYearData = data.thisYearData
        dataSet.thisYearProportion = data.thisYearProportion
        dataSet.totalCount = data.totalCount
        dataSet.totalRoomCount = data.totalRoomCount*/

        this.dataSet2 = dataSet2
        // 渲染表格
        this.renderCharts2()

        // // 后端返回的无权限
        // if (data.stateCode === -1) {
        //   this.$toast('暂无权限查看数据')
        //   return false
        // }
        // // 没数据
        // if (data.data.length <= 0) {
        //   this.$toast('当前日期暂无数据')
        // }
        // // 有数据时的 ★正常情况
        // this.tableData = data.data || []
        // this.totalData = data.footer[0] || {}
      }).catch((err) => {
        // 网络错误
        console.log(err)
        this.$toast.clear()
        this.$toast('网络异常 请稍后再试')
      })
    }
  },
  filters: {
    roundFilter (number) {
      console.log(number)
      return Math.trunc(number + 0)
    },
    thousandsFilter (number) {
      if (number) {
        let arr = String(number).split('.')
        let num = arr[0]
        let len = Math.ceil(num.length / 3) * 3
        let result = num.padStart(len, '0').match(/\d{3}/g).join(',').replace(/^0+/, '')
        return arr[1] ? result + '.' + arr[1] : result
      } else {
        return ''
      }
    },
    keepTwoDecimalFilter (number) {
      if (number) {
        const reg = /^(.*\..{2}).*$/
        return Number(String(number).replace(reg, '$1'))
      } else {
        return ''
      }
    },
    cutDateStr (dateString) {
      return dateString.substring(0, 10)
    }
  }
}
</script>

<style lang="less" scoped>

.page-cover {
  width: 7.5rem;
  margin: 0 auto;
  background-color: #f2f3f6;

  /deep/ .van-calendar__selected-day {
    background-color: #0e43a4 !important;
  }

  /deep/ .van-calendar__day--start {
    background-color: #0e43a4 !important;
  }

  /deep/ .van-calendar__day--end {
    background-color: #0e43a4 !important;
  }

  /deep/ .van-calendar__day--middle {
    background-color: #aad8ff !important;
    color: #666;
  }

  /deep/ .van-button--danger {
    color: #fff;
    background-color: #0e43a4;
    border: 1px solid #0e43a4;
  }

  /deep/ .van-button--primary {
    background-color: #1948b3;
    border: 1px solid #1948b3;
  }


  .date-area {
    position: fixed;
    left: 0;
    top: 0;

    width: 100%;
    height: .96rem;
    z-index: 100;
    background-color: #fff;
    text-align: center;
    font-size: .36rem;
    line-height: .86rem;
    padding-top: .1rem;
    color: #191919;
    letter-spacing: 0;
  }

  .van-tabs__wrap {
    position: fixed;
    left: 0;
    top: .96rem;
    width: 100%;
    height: 0.92rem !important;
    box-shadow: 0 .04rem .09rem 0 rgba(0, 0, 0, 0.06);
    z-index: 100;
    background-color: #fff;
  }

  .van-tab {
    .van-tab__text {
      font-size: .3rem;
      color: #7F8389;
    }
  }

  .van-tab--active {
    .van-tab__text {
      font-size: .3rem;
      color: #191919;
      font-weight: bold;
    }
  }

  .van-tabs__line {
    background-color: #191919 !important;
    width: 26px !important;
    bottom: 16px !important;
  }

  .tab-inner {
    background-color: #f2f3f6;
  }

  .pc-scroll {
    .van-tabs__wrap {
      overflow-x: auto;
      overflow-y: hidden;
      box-shadow: none;

      .van-tabs__nav {
        overflow-y: unset;
        overflow-x: unset;
      }
    }

  }

  .van-calendar__selected-day {
    background-color: #0e43a4 !important;
  }

  .van-button--danger {
    color: #fff;
    background-color: #0e43a4;
    border: 1px solid #0e43a4;
  }
}

.day-part {
  width: 6.9rem;
  background-color: #fff;
  margin-left: .3rem;
  font-size: .26rem;
  margin-bottom: .34rem;
  border-radius: .12rem;
  padding-bottom: .33rem;

  .date-info {
    width: 6.36rem;
    margin-left: .27rem;
    border-bottom: 1px solid #EAEAEC;
    overflow: hidden;
    position: relative;

    .today-tag {
      width: .78rem;
      height: .38rem;
      background-color: #6287ce;
      border-radius: .19rem;
      color: #fff;
      text-align: center;
      position: absolute;
      right: .06rem;
      top: .36rem
    }

    .weekday {
      font-size: .28rem;
      margin-top: .21rem;
      color: #191919;
      line-height: .4rem;
      font-weight: bold;
    }

    .date-value {
      opacity: 0.6;
      font-size: .22rem;
      color: #7F7F7F;
      line-height: .3rem;
      margin-top: .02rem;
      margin-bottom: .17rem;
    }
  }

  .today-content {
    line-height: .37rem;
    font-size: .26rem;
    color: #424242;
    width: 6.36rem;
    margin-left: .27rem;
    margin-top: .23rem;
  }

  .summarize {
    line-height: .37rem;
    font-size: .26rem;
    color: #424242;
    width: 6.36rem;
    margin-left: .27rem;

    .sum-title {
    }

    .sum-content {
    }
  }
}


.header-wrap {
  background-color: #fff;
  width: 6.9rem;
  height: 1.17rem;
  margin-left: .3rem;
  border-radius: .16rem .16rem 0 0;
  margin-top: .4rem;

  .date {
    float: left;
    font-size: .32rem;
    line-height: .45rem;
    margin-top: .36rem;
    margin-left: .33rem;
    font-weight: bold;
    color: #191919;
  }

  .total-count-room {
    float: right;
    font-size: .24rem;
    line-height: .33rem;
    margin-top: .28rem;
    margin-right: .42rem;
    color: #7f7f7f;
  }
}

.main-chart {
  &.half-height {
    height: 4rem;
  }
  width: 6.9rem;
  height: 7.98rem;
  background-color: #fff;
  margin-left: .3rem;
  border-radius: 0 0 .16rem .16rem;
}

.total-area {
  width: 6.9rem;
  margin-left: .3rem;
  margin-top: .4rem;
  background-color: #fff;
  border-radius: .16rem;
  overflow: hidden;
  padding-bottom: .45rem;

  .area-title {
    font-weight: bold;
    font-size: .28rem;
    color: #191919;
    line-height: .4rem;
    margin-top: .36rem;
    margin-left: .34rem;
    margin-bottom: .41rem;
  }

  .total-list {
    display: flex;
    justify-content: space-between;
    font-size: .28rem;
    line-height: .4rem;
    padding-left: .34rem;
    padding-right: .34rem;
    margin-top: .25rem;

    .date {
      color: #191919;
      width: 43%;
    }

    .room-count {
      color: #191919;
      font-weight: bold;
      width: 23%;
    }

    .per {
      color: #41A4FF;
      font-weight: bold;
      width: 33%;
    }
  }

  .no-data {
    text-align: center;
    color: #999;
    font-size: .2rem;

  }
}

.chart-title {
  background-color: #fff;
  width: 6.9rem;
  margin-left: .3rem;
  text-align: center;
  font-size: .42rem;
  line-height: .88rem;
}

.btn-group {
  background-color: #fff;
  width: 6.7rem;
  margin-left: .3rem;
  text-align: right;
  font-size: .42rem;
  line-height: .88rem;
  padding-right: .2rem;
  padding-bottom: .1rem;
}

</style>

